export const stateKorea = (state: string) => {
  switch (state) {
    case 'MEMBER':
      return '일반회원';
    case 'SIGNUP_REQUEST':
      return '가입신청자';
    case 'REJECT':
      return '거절';
    default:
      return '수정신청자';
  }
};
